import { reducer } from './widget_translation_reducer';

export default reducer;
